import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "BaseTemplateReceiptLayers" }
const _hoisted_2 = { class: "flex items-center q-mb-md gap-xs" }
const _hoisted_3 = { class: "fw-500 text-cool-gray-100 q-mb-none fs-17px" }
const _hoisted_4 = { class: "column gap-md" }
const _hoisted_5 = { class: "column gap-sm" }

import translate from 'src/common/helpers/language/translate'
import translationObject from '../../translate/baseTemplate.translate'
import BaseTemplateLayerItem from './BaseTemplateLayerItem.vue'
import useDrag from 'src/hook/useDrag.js'
import { useTemplateStore } from 'src/stores'
import { scrollToElementId } from 'src/common/helpers/functions/scrollToElementId'
import type { ITemplateDeleteItemParam, ITemplateLayer } from 'src/common/interfaces'

interface IEmits {
  (event: 'delete', data: ITemplateDeleteItemParam): void
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseTemplateReceiptLayers' },
  __name: 'BaseTemplateReceiptLayers',
  emits: ["delete"],
  setup(__props) {




const dragHook = useDrag()
const { t } = translate(translationObject)
const templateStore = useTemplateStore()

function onBeforeAccordionHide() {
  // when click on the sections and change the state of activeLayer, before-hide event here trigger and buggy situation occur in dropdown model
  // so i check if it from section skip it and dont update activeLayer with new state
  if (templateStore.activeLayer.updatedFrom === 'section')
    templateStore.handleActiveLayer({
      ...templateStore.activeLayer,
      updatedFrom: null,
    })
  else templateStore.handleActiveLayer({ index: -1 })
}

function handleScrollIntoSection(layer: ITemplateLayer) {
  templateStore.handleActiveItem({})
  scrollToElementId(layer.id, { behavior: 'smooth', block: 'center' })
}

return (_ctx: any,_cache: any) => {
  const _component_k_input = _resolveComponent("k-input")!
  const _component_k_divider = _resolveComponent("k-divider")!
  const _component_k_accordion = _resolveComponent("k-accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_k_input, {
      modelValue: _unref(templateStore).templateName,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(templateStore).templateName) = $event)),
      "external-label": _unref(t)('template_name')
    }, null, 8, ["modelValue", "external-label"]),
    _createVNode(_component_k_divider, {
      class: "q-my-md",
      dotted: true,
      color: "cool-gray-50"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('layers.title')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templateStore).layers, (layer, layerIndex) => {
        return (_openBlock(), _createBlock(_component_k_accordion, {
          key: layerIndex,
          title: _unref(t)(layer.title),
          "title-class": "fs-15px",
          group: "template-layers",
          "model-value": _unref(templateStore).activeLayer.index === layerIndex,
          onBeforeHide: _cache[1] || (_cache[1] = ($event: any) => (onBeforeAccordionHide())),
          onAfterShow: ($event: any) => (_unref(templateStore).handleActiveLayer({ index: layerIndex, id: +layer.id })),
          onClick: ($event: any) => (handleScrollIntoSection(layer))
        }, {
          "before-title": _withCtx(() => [
            _createElementVNode("div", {
              class: "BaseTemplateReceiptLayers__badge q-mr-xs rounded-8",
              style: _normalizeStyle({ backgroundColor: layer.color })
            }, null, 4)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(layer.items, (item, itemIndex) => {
                return (_openBlock(), _createBlock(BaseTemplateLayerItem, {
                  key: item.id,
                  item: item,
                  "layer-index": layerIndex,
                  "is-active": _unref(templateStore)?.activeItem?.id === item.id,
                  onClick: ($event: any) => (_unref(templateStore).handleActiveItem(item)),
                  onToggleShow: ($event: any) => (_unref(templateStore).handleToggleShow(layerIndex, itemIndex)),
                  onItemDragstart: _unref(dragHook).handleDragStart,
                  onItemDragend: ($event: any) => (
              _unref(dragHook).handleDragEnd({
                items: layer.items,
                callback: _unref(templateStore).handleRowDragged,
                layerIndex,
              })
            ),
                  onItemDragover: _unref(dragHook).handleDragOver,
                  onDelete: ($event: any) => (_ctx.$emit('delete', { layerIndex, itemIndex }))
                }, null, 8, ["item", "layer-index", "is-active", "onClick", "onToggleShow", "onItemDragstart", "onItemDragend", "onItemDragover", "onDelete"]))
              }), 128))
            ])
          ]),
          _: 2
        }, 1032, ["title", "model-value", "onAfterShow", "onClick"]))
      }), 128))
    ])
  ]))
}
}

})